import React from "react"
import { LinkButton } from "../../components/button/Button"
import { Header } from "../../components/header/Header";
import { useLocale } from "../../services/DataContext";
import campaignLogo from "../../assets/campaign-logo.png";
import campaignLogoMobile from "../../assets/campaign-logo-mobile.svg";
import clientLogo from "../../assets/client-logo.svg"
export interface SplashPageProps {

}

export const SplashPage: React.FC<SplashPageProps> = (props) => {
  const l: any = useLocale();
  return <div className="splash-page">
    <Header className="splash-page__header" />
    <div className="container">
      <div className="splash-page__content">
        <div className="splash-page__row splash-page__client-logo animate__animated animate__fadeIn">
          <div className="client-logo">
            <img src={`${clientLogo}`} alt="client-logo" />
          </div>

        </div>
        <div className="splash-page__row splash-page__campaign-logo animate__animated animate__fadeIn delay-3">
          <div className="campaign-logo">
            <img className="hide-on-medium" src={campaignLogoMobile} alt="" />
            <img className="hide-on-small" src={campaignLogo} alt="" />
          </div>
        </div>
        <div className="splash-page__row splash-page__campaign-description animate__animated animate__fadeInUp delay-5">
          <div className="row">
            <div className="col">
              <div
                dangerouslySetInnerHTML={{ __html: l.splashDescription }}
                className="">

              </div>
            </div>
          </div>
          <LinkButton href="/content/hypes">
            Enter
          </LinkButton>
        </div>
        <div className="splash-page__button">
        </div>
      </div>
    </div>
  </div>
}